import { useMutation } from "react-query";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { queryClient } from "shared/util/queryClient";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";
import { ConfigurarBuscaEmailRequest } from "types/request/groupPay/ConfigurarBuscaEmailRequest";
import { ConfiguracaoEmailResponse } from "types/response/groupPay/ConfiguracaoEmailResponse";

type AxiosPostResponse = {
  data: Cond21CloudResponse<ConfiguracaoEmailResponse>;
};

interface UseConfigurarBuscaEmailProps {
  onSuccess?: (response: Cond21CloudResponse<ConfiguracaoEmailResponse>) => void;
  onError?: (error: any) => void;
}

export const usePostConfigurarBuscaEmail = ({ onSuccess, onError }: UseConfigurarBuscaEmailProps = {}) => {
  return useMutation<AxiosPostResponse, any, ConfigurarBuscaEmailRequest>({
    mutationFn: (payload) => {
      return http.post(api.groupPay.configuracaoEmail, payload);
    },
    onSuccess: (axiosResponse) => {
      queryClient.invalidateQueries(["configuracao-group-pay"]);      
      
      if (onSuccess) {
        onSuccess(axiosResponse.data); 
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
  });
};